import styled from 'styled-components';

import { StyleColor, NewStyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

interface ButtonProps {
	isActive: boolean;
	isBold?: boolean;
	isItalic?: boolean;
	isUnderline?: boolean;
	isLineThrough?: boolean;
}

const Section = styled('div')`
	padding: 0 5px;
	border-radius: 8px;
	background-color: ${hexToRgba(StyleColor.White, 10)};

	& + & {
		margin-top: 15px;
	}

	>:not(:last-child) {
		border-bottom: 1px solid ${hexToRgba(StyleColor.Grey450, 30)};
	}
`;

const ButtonsWrapper = styled('div')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	height: 51px;
`;

const Button = styled('button').attrs({
	type: 'button',
})`
	box-sizing: border-box;
	flex: 1 1 33.33%;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 43px;
	margin: 0;
	padding: 0 10px;
	border: 0;
	border-radius: 6px;
	outline: 0;
	background-color: ${({ isActive }: ButtonProps) => isActive ? NewStyleColor.Blue450 : 'transparent'};
	font-family: HelveticaNeue, sans-serif;
	font-size: 18px;
	line-height: 43px;
	color: ${StyleColor.White};
	cursor: pointer;

	&:hover {
		background-color: ${({ isActive }: ButtonProps) => isActive ? NewStyleColor.Blue450 : hexToRgba(StyleColor.White, 10)};
	}

	& + & {
		margin-left: 3px;
	}

	svg {
		width: 23px;
		height: 24px;
		fill: currentColor;
	}

	${(props: ButtonProps) => {
		if (props.isBold) {
			return `font-weight: bold;`;
		}
		if (props.isItalic) {
			return `
				font-family: Times, 'Times New Roman', serif;
				font-style: italic;
			`;
		}
		if (props.isUnderline) {
			return `text-decoration: underline;`;
		}
		if (props.isLineThrough) {
			return `text-decoration: line-through;`;
		}
		return;
	}}
`;

const SubScript = styled('span')`
	position: relative;
	top: 0.35em;
	padding-left: 3px;
	font-size: 60%;
`;

const SuperScript = styled('span')`
	position: relative;
	top: -0.35em;
	padding-left: 2px;
	font-size: 60%;
`;

export {
	Section,
	ButtonsWrapper,
	Button,
	SubScript,
	SuperScript,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/TextPanel/styles.ts